/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { JwtCreateRequest } from '../models/JwtCreateRequest';
import type { JwtTokenPair } from '../models/JwtTokenPair';
import type { TokenRefresh } from '../models/TokenRefresh';
import type { TokenVerify } from '../models/TokenVerify';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class JwtService {
  /**
   * @param data
   * @returns JwtTokenPair
   * @throws ApiError
   */
  public static authJwtCreateCreate(
    data: JwtCreateRequest,
  ): CancelablePromise<JwtTokenPair> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/auth/jwt/create',
      body: data,
    });
  }
  /**
   * Takes a refresh type JSON web token and returns an access type JSON web
   * token if the refresh token is valid.
   * @param data
   * @returns TokenRefresh
   * @throws ApiError
   */
  public static authJwtRefreshCreate(
    data: TokenRefresh,
  ): CancelablePromise<TokenRefresh> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/auth/jwt/refresh',
      body: data,
    });
  }
  /**
   * Takes a token and indicates if it is valid.  This view provides no
   * information about a token's fitness for a particular use.
   * @param data
   * @returns TokenVerify
   * @throws ApiError
   */
  public static authJwtVerifyCreate(
    data: TokenVerify,
  ): CancelablePromise<TokenVerify> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/auth/jwt/verify',
      body: data,
    });
  }
}
